module.exports = __webpack_public_path__ + "img/reviews.fd327d2a.svg";